const HomeReferralSplash = require('./home-referral-splash.png')
const HomeReferralSplashLarge = require('./home-referral-splash-large.png')
const Smile = require('./smile.png')
const AppStoreButton = require('./app-store-button.svg')
const PlayStoreButton = require('./play-store-button.svg')

export default {
	HomeReferralSplash,
	HomeReferralSplashLarge,
	Smile,
	AppStoreButton,
	PlayStoreButton,
}
